import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs';
import { PdvSelectors } from 'src/app/store/pdv/selectors';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent {
  policy$ = this.store.pipe(
    select(PdvSelectors.selectCompany),
    map((company) => {
      const policy = company?.policy ?? '';
      return this.sanitizer.bypassSecurityTrustHtml(
        policy.replace(/\{company\.name\}/g, window.location.hostname.startsWith("goianao2025.com.br") ? 'Goianão' : (company?.name ?? ''))
          .replace(/\{company\.site\}/g, window.location.hostname.startsWith("goianao2025.com.br") ? 'goianao2025.com.br' : (company?.site ?? ''))
      );
    })
  );

  constructor(
    private store: Store,
    private sanitizer: DomSanitizer
  ) {}
}
